module.exports = __webpack_public_path__ + "img/lessonpre_next_left.9167432b.svg";